export const wrappSubMenu = () => {
  if(document.querySelector('#primaryMenu')) {
    const mainMenu = document.querySelector('#primaryMenu');
    const mainMenuItems = mainMenu.querySelectorAll('.menu-item');
    const subMenus = mainMenu.querySelectorAll('.sub-menu');

    if(mainMenuItems && subMenus) {
      subMenus.forEach((subMenu) => {
        const subMenuWrapper = document.createElement('div');
        subMenuWrapper.classList.add('submenu-wrapper');

        subMenu.parentNode.insertBefore(subMenuWrapper, subMenu);
        subMenuWrapper.appendChild(subMenu);
      });
    }

    if(mainMenuItems) {
      mainMenuItems.forEach((menuItem) => {
        let timer;
        
        menuItem.addEventListener('mouseover', function () {
          const subMenuWrapper = this.querySelector('.submenu-wrapper');
          const subMenu = this.querySelector('.sub-menu');

          clearTimeout(timer);

          if(subMenu) {
            subMenuWrapper.classList.add('d-block');
            subMenu.classList.add('d-flex');

            // timer = setTimeout(() => {
              subMenuWrapper.classList.add('visible');
            // }, 200);
          }
        });

        menuItem.addEventListener('mouseleave', function () {
          const subMenuWrapper = this.querySelector('.submenu-wrapper');
          const subMenu = this.querySelector('.sub-menu');

          if(subMenu) {

            timer = setTimeout(() => {
            subMenuWrapper.classList.remove('visible');
              subMenuWrapper.classList.remove('d-block');
              subMenu.classList.remove('d-flex');
            }, 600);
          }
        });
      });
    }
  }
}